<!--
soho-busyindicator needed here for paging.
-->
<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="20"
     [timeToComplete]="this.uiLoadingIndicatorTimeout"
     [transparentOverlay]="true"
>
    <div soho-calendar #SohoCalendarComponent
         [month]="initialMonth"
         [year]="initialYear"
         [showViewChanger]="showViewChanger"
         [eventTooltip]="eventTooltip"
         [iconTooltip]="iconTooltip"
         [renderMonthCallback]="onRenderMonthCallback"
         (eventClick)="onCalendarEventDblClicked($event)"
         (eventDblClick)="onCalendarEventDblClicked($event)"
         (eventContextMenu)="onCalendarEventContextMenu($event)"
         menuId="{{contextMenuId}}"
    >
        <div class="calendar-events" *ngIf="showLegend()">
            <soho-accordion [allowOnePane]="false">

                <soho-accordion-header [isExpanded]="true">
                    <a href="#"><span data-translate="text">Legend</span></a>
                </soho-accordion-header>
                <soho-accordion-pane>
                    <div class="calendar-event-types accordion-content"></div>
                </soho-accordion-pane>

            </soho-accordion>
        </div>

<!--        <soho-accordion [allowOnePane]="true" *ngIf="showLegend()">-->
<!--            <soho-accordion-header [isExpanded]="true">{{ 'Legend' | translate }}</soho-accordion-header>-->
<!--            <soho-accordion-pane>-->
<!--                <div class="accordion-content" [ngStyle]="{'text-align': 'center'}">-->
<!--                    <ng-container *ngFor="let legendState of legends">-->
<!--                        <span [ngStyle]="{'margin-left': '20px'}">-->
<!--                            <input type="checkbox" [ngClass]="getLegendColorId(legendState.color)" soho-checkbox  [disabled]="false"/>-->
<!--                            <label soho-label [forCheckBox]=true>{{ legendState.label }}</label>-->
<!--                        </span>-->
<!--                    </ng-container>-->
<!--                </div>-->
<!--            </soho-accordion-pane>-->
<!--        </soho-accordion>-->

        <div soho-calendar-monthview></div>
        <div soho-calendar-week-view></div>
    </div>
</div>
<div #modalPlaceholder id="modalPlaceholder"></div>
